import axiosInstance from "axiosInstance";

const API_URL = process.env.REACT_APP_CP_API_URL;

export async function fetchRolePermissions(role: string): Promise<string[]> {
  const { data } = await axiosInstance.get(
    `${API_URL}/api/admin/role_permissions`,
    { params: { role } },
  );
  return data.resource_keys;
}

export async function updateRolePermissions(
  role: string,
  resourceKeys: string[],
): Promise<string[]> {
  const { data } = await axiosInstance.put(
    `${API_URL}/api/admin/role_permissions/bulk_update`,
    { role, resource_keys: resourceKeys },
  );
  return data.resource_keys;
}
